import { CustomHookService } from './../../shared-services/custom-hook/custom-hook.service';
import { AgentService } from './../../../BaseFramework/core/http/agent.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  ValidationUtilService,
  ApiRequestService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ClientService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { take } from 'rxjs/operators';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { result } from 'lodash';

@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.scss']
})
export class ClientSearchComponent implements OnInit {
  _currentComponentName = 'ClientSearchComponent'
  constructor(
    private metadataService: MetadataService,
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private interactService: InteractService,
    private clientService: ClientService,
    public appMetadataHandler: AppMetadataHandler,
    private agentService: AgentService,
    private customHookService: CustomHookService,
    private msg: NzMessageService
  ) { }

  //Declaraions
  clientSearchCriteriaForm: FormGroup
  CLIENTSEARCHCRITERIAFORMNAME = "clientSearchCriteriaForm"
  currentPage: any = 0;
  itemsPerPage: any = 20;
  searchObservable
  selectedCustomer: any
  public CRITERIALOOKUP = [];
  public clientDataSet = []
  public policyDataSet = []
  public tempPolicyDataSet = []
  public checkedPolicyDataList = []

  //TODO Added for AOT
  attemptToSubmit() { }

  ngOnInit() {
    this.multiLingualService.setLanguageForLazyLoadedComponents(this.translateService)
    var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cGeneric Policy Search : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log("%c<app-client-search'></app-client-search'>, has been used. ", consoleStyle)
      console.log("%cYou can override following attributes -----------------------------------", consoleStyle)
      console.log("%cExample , <app-client-search></app-client-search'>", consoleStyle)
      console.groupEnd();
    }
    // this.metadataService.getSearchCriteriaList('searchProposal').subscribe(resp => {
      this.metadataService.getSearchCriteriaList('searchInsured').subscribe(resp => {
      this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
      console.log('this is criteria lookup',this.CRITERIALOOKUP);
    });
    this.initializeClientSearchForm()
    this.subscribeToParentEvent()

  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.custSearchFor == 'POLICY')
      this.emitSelectedPolicies(true)
  }

  /**
   * ComponentSpecific Inputs, Outputs and Functions
   *  
   */
  @Output() componentOutput = new EventEmitter<any>();
  @Input() title: string = "No Data";
  @Input() list: Array<any>
  @Input() custSearchFor: string
  @Input() clientRole: string;
  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  parentEvent$
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(this.getSelected())
    })
  }

  getSelected() {
    return this.policyDataSet.filter(data => data.selected)
  }

  searchCustomer$
  searchAgent$
  searchCustomer() {
    console.log("client role in search customer function", this.clientRole);
    var formObject = {
      firstName: this.clientSearchCriteriaForm.get('firstName').value,
      lastName: this.clientSearchCriteriaForm.get('lastName').value,
      proposalNum: this.clientSearchCriteriaForm.get('proposalNum').value,
      criteriaDOB: this.clientSearchCriteriaForm.get('dateOfBirth').value
    }

    var payload = this.convertToSearchRequestPayload(formObject)
    if (this.clientRole === 'Agent') {
      if (this.searchAgent$) this.searchAgent$.unsubscribe();
      this.searchAgent$ = this.agentService.searchAgent(payload).pipe(take(1)).subscribe(agentData => {
        this.clientDataSet = agentData.results;
      })

    } else {
      if (this.searchCustomer$ != null) this.searchCustomer$.unsubscribe();
      this.searchCustomer$ = this.clientService.getInsuredByPolicy(payload).pipe(take(1)).subscribe(data => {
        this.clientDataSet = data.results;
      });
    }
    console.log(payload)
  }


  /* Search by Customer or Policy */
  tempVariable = "ClientSearch"
  searchCustOrPolicyLoading: boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }

  modSearchCustOrPolicy: boolean = false;

  showCustomerPolicies: boolean = false;
  showCustomerPoliciesName: string = '';


  viewAddCustomersPolicies(data) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = data.firstName + " " + data.lastName;
    var payload = this.convertToSearchRequestPayloadPolicy(data.guid);
    if (this.searchObservable != null)
      this.searchObservable.unsubscribe();
    this.searchObservable = this.apiRequestService.postCallWithAPIMapper("claimSearchInsuredPolicy", payload).subscribe(data => {
      this.policyDataSet = this.commonUtilty.deepCopy(data.results);

    });
  }


  /**
   * Form Trasactions
   */

  initializeClientSearchForm() {
    this.clientSearchCriteriaForm = this.fb.group({
      firstName: this.validationUtilService.setValidationsForFormControl('firstName', this.CLIENTSEARCHCRITERIAFORMNAME),
      lastName: this.validationUtilService.setValidationsForFormControl('lastName', this.CLIENTSEARCHCRITERIAFORMNAME),
      proposalNum: this.validationUtilService.setValidationsForFormControl('proposalNum', this.CLIENTSEARCHCRITERIAFORMNAME),
      dateOfBirth: this.validationUtilService.setValidationsForFormControl('dateOfBirth', this.CLIENTSEARCHCRITERIAFORMNAME)

    });
  }

  convertToSearchRequestPayload(formObject) {
    console.log(formObject)
    var payload = {}
    payload["page"] = this.currentPage
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    var attributes = JSON.parse(JSON.stringify(Object.keys(formObject)));

    attributes.forEach(key => {
      var criteriaItem = {}
      criteriaItem["paramName"] = key
      criteriaItem["paramValue"] = formObject[key];
      payload["searchCriteriaList"].push(criteriaItem)
    });

    return payload
  }

  convertToSearchRequestPayloadPolicy(guid) {
    var payload = {}
    payload["page"] = this.currentPage
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    var criteriaItem = {}
    criteriaItem["paramName"] = "guid"
    criteriaItem["paramValue"] = guid;
    payload["searchCriteriaList"].push(criteriaItem)
    return payload
  }
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  getSelectedPolicies() {
    return this.policyDataSet.filter(d => d.selected)
  }

  getSelectedClient() {
    return this.clientDataSet.filter(d => d.selected)
  }

  emitSelectedPolicies(event) {
    console.log(JSON.stringify(event))
    let selectedPolicies = this.getSelectedPolicies();
    this.tempPolicyDataSet = this.getSelectedPolicies();
    // this.EmitComponentOutput(selectedPolicies) 
    this.interactService.sendSelectedPolicyToPolicyList(selectedPolicies)
  }

  emitSelectedClient(data) {
    if (data) {
      this.fetchClientDOforSelectClient(data)
      this.selectedCustomer = data
    }
  }

  fetchClientDOforSelectClient(data) {
    console.log("client role in client search", this.clientRole);
    if (data.id) {
      this.clientService.getClientById(data.id)
        .subscribe(resp => {
          console.log(JSON.stringify(resp));
          let output = { selectedClientData: [data], fetchedClientData: [resp] }
          let clientList = { role: this.clientRole, clientDO: resp }
          this.EmitComponentOutput(output)
          this.interactService.sendNomineeListToBankDetails([resp])
          this.interactService.sendClientDOtoClientList(clientList)
          this.customHookService.customHookInsuredList();

        },
          (error) => {

            throw " Something went wrong";
          }
        );
    }
  }
  dataSet;
  public intimationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }
  length=0
  fetchSearchResult($event) {  
    console.log("123");
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        this.dataSet.forEach(result=>{
          if(result.clientNum!==null){
            this.length++
          }
        })
        if(this.length===0){
          this.intimationZeroState.title = "No Results found"
          this.intimationZeroState.message = "No records available for the selected search criteria."
          this.msg.error("No result found.")
        }
        console.log("proposal search data", JSON.stringify(this.dataSet));
      }
      else {
        this.dataSet = []
      }
    }
    else {
      this.dataSet = []
    }
  }
}
